import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';
import { registerDecoration } from 'core/forms';

import { FormField } from 'uikit/forms';
import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationUsage.module.css';

const ListItem = ({ children = null }) => (
  <li>
    <Typo color="secondary" element="span" variant="b01">
      {children}
    </Typo>
  </li>
);

ListItem.propTypes = {
  children: PropTypes.node,
};

const FormDecorationUsage = ({ fieldId = '', fieldKey = '', model = {}, schema = {} }) => (
  <FormField fieldId={fieldId} label={schema.label} schema={{}} type="Decoration">
    <ul className={styles.element}>
      {model[fieldKey]?.map(({ code, id, name }) => (
        <ListItem key={id}>{code ? i18n.t('name-code', { code, name }) : name}</ListItem>
      )) || <ListItem>{i18n.t('none')}</ListItem>}
    </ul>
  </FormField>
);

FormDecorationUsage.propTypes = {
  fieldId: PropTypes.string,
  fieldKey: PropTypes.string,
  model: PropTypes.shape({}),
  schema: PropTypes.shape({ label: PropTypes.string }),
};

registerDecoration('Usage', React.memo(FormDecorationUsage));

export default FormDecorationUsage;
